// extracted by mini-css-extract-plugin
export var columnItem = "_ba-3";
export var columnItemDraggable = "_ba-4";
export var dragHandle = "_ba-0";
export var dragHandleHovered = "_ba-1";
export var dropdown = "_ba-5";
export var dropdownContent = "_ba-7";
export var dropdownInner = "_ba-6";
export var filterDropdownHeader = "_ba-8";
export var icon = "_ba-2";
export var sectionDivider = "_ba-9";